module.exports = __webpack_public_path__ + "static/media/airthium_featured.4a54dac0.jpg";